import dayjs from "dayjs";
import { MonitoredWorkOrderDatumResponse } from "../data/InvarDataModels/MonitoredWorkOrderDatumResponse";
import { MonitoredWorkOrderResponse } from "../data/InvarDataModels/MonitoredWorkOrderResponse";
import { useEffect, useMemo, useState } from "react";
import layout from "../assets/css/Components/WorkOrderTimeline.module.css";

type WorkOrderTimelineProps = {
  StartDate: dayjs.Dayjs;
  EndDate: dayjs.Dayjs;
  WorkOrders: Array<MonitoredWorkOrderResponse>;
  WorkOrderData: Array<MonitoredWorkOrderDatumResponse>;
};

export default function WorkOrderTimeline(props: WorkOrderTimelineProps) {
  // const [JSStart, SetJSStart] = useState<dayjs.Dayjs>();
  // const [JSEnd, SetJSEnd] = useState<dayjs.Dayjs>();

  //  useEffect(() => {
  //      if (props.WorkOrders !== undefined && props.WorkOrderData !== undefined) {
  //
  //          // find the beginning and end of the time window
  //          let _start: dayjs.Dayjs | undefined = undefined;
  //          let _end: dayjs.Dayjs | undefined = undefined;
  //
  //          props.WorkOrders.forEach(th => {
  //              let _jscr = dayjs(th.Created);
  //              if (_jscr.isBefore(_start) || _start === undefined) {
  //                  _start = _jscr;
  //              }
  //
  //              if (_jscr.isAfter(_end) || _end === undefined) {
  //                  _end = _jscr;
  //              }
  //          });
  //
  //          props.WorkOrderData.forEach(th => {
  //              let _jscr = dayjs(th.Created);
  //
  //              if (_jscr.isBefore(_start) || _start === undefined) {
  //                  _start = _jscr;
  //              }
  //
  //              if (_jscr.isAfter(_end) || _end === undefined) {
  //                  _end = _jscr;
  //              }
  //          });
  //
  //          if (_end.diff(_start, "minute") < 15) {
  //              _end = _start.add(15, "minute");
  //          }
  //
  //          console.log(_start);
  //          console.log(_end);
  //
  //          SetJSStart(_start);
  //          SetJSEnd(_end);
  //      }
  //  }, [props.WorkOrders, props.WorkOrderData])

  const [Window, SetWindow] = useState<number>();

  useEffect(() => {
    if (props.StartDate !== undefined && props.EndDate !== undefined) {
      SetWindow(props.EndDate.diff(props.StartDate));
    }
  }, [props.StartDate, props.EndDate]);

  const [SortedWorkOrders, SetSortedWorkOrders] = useState<
    Array<MonitoredWorkOrderResponse>
  >([]);
  useEffect(() => {
    SetSortedWorkOrders(props.WorkOrders.sort((th) => th.WorkOrderID));
  }, [props.WorkOrders]);

  const [DisplayRows, SetDisplayRows] = useState<
    Array<Array<MonitoredWorkOrderResponse>>
  >([]);
  // for each entry in WorkOrder,
  // starting from row 1
  // examine if it can be rendered in an existing row
  // or if a new row must be created to accommodate it.

  useMemo(() => {
    let NewDisplayRows: Array<Array<MonitoredWorkOrderResponse>> = [];

    NewDisplayRows[0] = [];

    props.WorkOrders.forEach((injectee) => {
      let iStar = dayjs(injectee.Created);
      let iComp = dayjs(injectee.Completed ?? props.EndDate);
      console.log(
        "Checking WO-" +
          injectee.WorkOrderID.toString() +
          " [" +
          iStar.format("HH-mm-ss") +
          " TO " +
          iComp.format("HH-mm-ss") +
          "]",
      );

      let inserted = false;

      // check all rows to see if any can take this workorder
      for (let i: number = 0; i < NewDisplayRows.length; i++) {
        if (inserted === false) {
          let ndr = NewDisplayRows[i];

          if (
            ndr.every((wo) => {
              let eStar = dayjs(wo.Created);
              let eComp = dayjs(wo.Completed ?? props.EndDate);
              let noverlap =
                // start dt must NOT be BETWEEN candidate times
                !(eStar.isAfter(iStar) && eStar.isBefore(iComp)) &&
                // end dt must NOT be BETWEEN candidate times
                !(eComp.isAfter(iStar) && eComp.isBefore(iComp)) &&
                // candidate start dt must NOT be BETWEEN times
                !(iStar.isAfter(eStar) && iStar.isBefore(eComp)) &&
                // candidate end dt must NOT be BETWEEN times
                !(iComp.isAfter(eStar) && iComp.isBefore(eComp));
              console.log(
                "Checking eWO-" +
                  wo.WorkOrderID.toString() +
                  " [" +
                  eStar.format("HH-mm-ss") +
                  " TO " +
                  eComp.format("HH-mm-ss") +
                  "] - " +
                  (noverlap ? "_______" : "OVERLAP"),
              );

              // every entry in this row must NOT overlap with the candidate
              return noverlap;
            })
          ) {
            console.log(
              "Pushing eWO-" +
                injectee.WorkOrderID.toString() +
                " to row " +
                i.toString(),
            );
            ndr.push(injectee);
            inserted = true;
          }
        }
      }

      if (!inserted) {
        let ndr: Array<MonitoredWorkOrderResponse> = [];
        ndr.push(injectee);
        NewDisplayRows.push(ndr);
      }
    });

    console.log(NewDisplayRows);

    SetDisplayRows(NewDisplayRows);
  }, [JSON.stringify(SortedWorkOrders)]);

  return (
    <div className={layout.TimelineFrame}>
      <div className={layout.Timeline}>
        {props.StartDate !== undefined &&
        props.EndDate !== undefined &&
        Window !== undefined ? (
          DisplayRows.map((th, i) => {
            return (
              <div
                key={"DisplayRow_" + i.toString()}
                className={layout.TimelineRow}
              >
                {th.map((th, i) => {
                  let bIncomplete =
                    th.Completed === undefined || th.Completed === null;

                  let jsWOStart = dayjs(th.Created);
                  let jsWOEnd = bIncomplete
                    ? props.EndDate
                    : dayjs(th.Completed);

                  let startOffset = jsWOStart.diff(props.StartDate);
                  let endOffset = jsWOEnd.diff(jsWOStart);

                  let startOffsetPercentage = (startOffset / Window) * 100;
                  let endOffsetPercentage = (endOffset / Window) * 100;

                  return (
                    <div
                      key={"wo_" + i.toString()}
                      className={
                        layout.TimelineEntry +
                        " " +
                        (bIncomplete ? layout.Incomplete : layout.Completed)
                      }
                      style={{
                        position: "absolute",
                        left: startOffsetPercentage.toString() + "%",
                        width: endOffsetPercentage.toString() + "%",
                        // top: (((i % 9) * 2).toString() + "rem")
                      }}
                    >
                      {th.WorkOrderID.toString()}
                    </div>
                  );
                })}
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
